<template>
  <SnackBar ref="snackbar" />

  <v-dialog v-model="dialog" width="800">
    <v-card>
      <v-card-title>
        <h3>Termos de Uso do SISGIP</h3>
      </v-card-title>
      <v-card-text>
        <br />
        <p>Última atualização: 30/08/2023</p>
        <br />
        <p>
          Antes de utilizar o Software, leia atentamente estes Termos de Uso
          para entender os direitos e responsabilidades tanto do usuário quanto
          da SISGIP Ltda., a desenvolvedora do Software. Ao utilizar o Software,
          você concorda com estes Termos.
        </p>
        <br />
        <h4>1. Aceitação dos Termos</h4>
        <p>
          Ao acessar ou utilizar o Software, você concorda em cumprir estes
          Termos. Se você não concordar com esses Termos, por favor, não utilize
          o Software.
        </p>
        <br />
        <h4>2. Uso do Software</h4>
        <p>
          O Software permite que você integre sua conta do GitHub com outras
          funcionalidades. Para utilizar o Software, você precisará fornecer seu
          endereço de e-mail e nome de usuário do GitHub. Ao fornecer essas
          informações, você autoriza o Software a acessar sua conta do GitHub em
          seu nome e realizar ações que você explicitamente aprovar.
        </p>
        <br />
        <h4>3. Privacidade e Segurança</h4>
        <p>
          A segurança e a privacidade de seus dados são importantes para nós. Ao
          utilizar o Software, você concorda com nossa Política de Privacidade,
          que detalha como suas informações são coletadas, usadas e protegidas.
          Fornecer informações falsas ou de terceiros é estritamente proibido.
        </p>
        <br />
        <h4>4. Responsabilidades do Usuário</h4>
        <p>
          Você é responsável por manter suas informações de conta seguras e
          atualizadas. Não compartilhe suas credenciais de acesso com terceiros
          e tome medidas para proteger sua conta. Qualquer ação realizada por
          meio de sua conta será de sua inteira responsabilidade.
        </p>
        <br />
        <h4>5. Direitos de Propriedade</h4>
        <p>
          O Software, incluindo todos os seus componentes, é protegido por
          direitos autorais e outras leis de propriedade intelectual. A SISGIP
          Ltda. detém todos os direitos sobre o Software. Você não pode copiar,
          modificar, distribuir, vender ou explorar de qualquer forma o
          Software, exceto conforme expressamente autorizado por escrito pela
          SISGIP Ltda.
        </p>
        <br />
        <h4>6. Rescisão</h4>
        <p>
          Reservamo-nos o direito de suspender ou encerrar seu acesso ao
          Software a qualquer momento, por qualquer motivo, sem aviso prévio.
          Você pode interromper o uso do Software a qualquer momento.
        </p>
        <br />
        <h4>7. Limitação de Responsabilidade</h4>
        <p>
          O uso do Software é por sua conta e risco. Em nenhum caso a SISGIP
          Ltda. será responsável por danos diretos, indiretos, incidentais,
          especiais ou consequenciais decorrentes do uso ou da incapacidade de
          usar o Software.
        </p>
        <br />
        <h4>8. Alterações nos Termos</h4>
        <p>
          Podemos modificar estes Termos de tempos em tempos. Quaisquer
          alterações entrarão em vigor após a publicação das versões revisadas
          dos Termos no Software. É sua responsabilidade revisar periodicamente
          os Termos para estar ciente das modificações. Ao utilizar o Software,
          você reconhece que leu, entendeu e concordou com estes Termos de Uso.
          Se você não concordar com estes Termos, por favor, não utilize o
          Software. Se tiver alguma dúvida, entre em contato conosco em
          sisgip@dcomp.ufs.br.
        </p>
        <br />
        <p>
          <strong>SISGIP Ltda.</strong><br />
          Av. Marechal Rondom, s/n, Jardim Rosa Elze. 49.100-000 / São
          Cristóvão-SE<br />
          sisgip@dcomp.ufs.br<br />
          30/08/2023
        </p></v-card-text
      >
      <!-- <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green-darken-1" variant="text" @click="dialog = false">
          Disagree
        </v-btn>
        <v-btn color="green-darken-1" variant="text" @click="dialog = false">
          Agree
        </v-btn>
      </v-card-actions> -->
    </v-card>
  </v-dialog>

  <v-dialog v-model="dialogPrivacidade" width="800">
    <v-card>
      <v-card-title>
        <h3>Política de Privacidade do SISGIP</h3>
      </v-card-title>
      <v-card-text>
        <br />
        <p>Última atualização: 30/08/2023</p>
        <br />
        <p>
          A <strong>SISGIP Ltda.</strong> valoriza a sua privacidade e está
          comprometida em proteger as suas informações pessoais. Esta Política
          de Privacidade descreve como coletamos, usamos e protegemos as
          informações que você fornece ao utilizar o SISGIP. Ao utilizar o
          Software, você concorda com as práticas descritas nesta Política.
        </p>
        <br />
        <h4>1. Informações Coletadas</h4>
        <p>
          Para utilizar o Software, solicitamos que você forneça seu endereço de
          e-mail e nome de usuário do GitHub. Essas informações são necessárias
          para permitir a integração com a sua conta do GitHub e para realizar
          as ações que você autorizar por meio do Software.
        </p>
        <br />
        <h4>2. Uso das Informações</h4>
        <p>
          As informações coletadas são utilizadas exclusivamente para permitir a
          integração e funcionalidade do Software. Não compartilhamos suas
          informações pessoais com terceiros, a menos que seja estritamente
          necessário para fornecer os serviços do Software ou conforme exigido
          por lei.
        </p>
        <br />
        <h4>3. Acesso à Conta do GitHub</h4>
        <p>
          Ao fornecer suas informações de conta do GitHub, você nos autoriza a
          acessar sua conta e executar ações específicas que você aprovar por
          meio do Software. Não utilizaremos suas informações para outros fins
          além dos previstos neste Software, e não armazenaremos suas
          credenciais de login.
        </p>
        <br />
        <h4>4. Segurança das Informações</h4>
        <p>
          Temos medidas de segurança em vigor para proteger as suas informações
          pessoais contra acesso não autorizado, alteração, divulgação ou
          destruição. No entanto, lembre-se de que nenhum método de transmissão
          pela internet ou de armazenamento eletrônico é 100% seguro, e não
          podemos garantir a segurança absoluta das informações.
        </p>
        <br />
        <h4>5. Cookies e Tecnologias de Rastreamento</h4>
        <p>
          O Software não utiliza cookies nem tecnologias de rastreamento para
          coletar informações sobre sua navegação na internet.
        </p>
        <br />
        <h4>6. Alterações na Política de Privacidade</h4>
        <p>
          Podemos atualizar esta Política de Privacidade periodicamente para
          refletir mudanças em nossas práticas ou por outras razões. A data da
          "Última atualização" no início deste documento indicará a data da
          última revisão. Recomendamos que você reveja esta Política
          periodicamente para estar ciente de como estamos protegendo suas
          informações.
        </p>
        <br />
        <h4>7. Contato</h4>
        <p>
          Se você tiver dúvidas sobre esta Política de Privacidade ou sobre as
          práticas de privacidade do Software, entre em contato conosco em
          <a href="sisgip@dcomp.ufs.br">sisgip@dcomp.ufs.br</a>.
        </p>
        <br />
        <p>
          Agradecemos por confiar em nós para a integração com sua conta do
          GitHub. Sua privacidade é importante e estamos empenhados em proteger
          suas informações pessoais.
        </p>
        <br />
        <p>
          <strong>SISGIP Ltda.</strong><br />
          Av. Marechal Rondom, s/n, Jardim Rosa Elze. 49.100-000 / São
          Cristóvão-SE<br />
          sisgip@dcomp.ufs.br<br />
          30/08/2023
        </p></v-card-text
      >
      <!-- <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green-darken-1" variant="text" @click="dialog = false">
          Disagree
        </v-btn>
        <v-btn color="green-darken-1" variant="text" @click="dialog = false">
          Agree
        </v-btn>
      </v-card-actions> -->
    </v-card>
  </v-dialog>
  <div class="flex">
    <div class="branca">
      <v-container>
        <v-row class="mb-6" no-gutters>
          <v-col cols="6">
            <router-link to="/login" style="text-decoration: none"
              ><img width="230" src="@/assets/img/dcomp.png" alt=""
            /></router-link>
          </v-col>

          <v-col cols="6">
            <router-link to="/login" style="text-decoration: none"
              ><img width="250" src="@/assets/img/logo_UFS.png" alt=""
            /></router-link>
          </v-col>
        </v-row>
      </v-container>
      <div class="div-esq">
        <v-sheet width="400" class="mx-auto">
          <h2 class="poppins400">Cadastre-se!</h2>

          <div class="justify-content">
            <h5 class="poppins400">Se você já tem uma conta</h5>
            <h5>
              <a class="poppins400"
                >Entre
                <router-link to="/login" style="text-decoration: none"
                  >aqui!</router-link
                ></a
              >
            </h5>
          </div>

          <v-form @submit.prevent="validateForm">
            <v-text-field
              v-model="email"
              required
              :rules="rules"
              variant="underlined"
              label="Email"
              prepend-inner-icon="mdi-email-outline"
            >
            </v-text-field>

            <v-text-field
              v-model="nome"
              label="Insira seu nome"
              variant="underlined"
              prepend-inner-icon="mdi-account-outline"
              required
            ></v-text-field>

            <v-text-field
              v-model="token"
              label="Token"
              prepend-inner-icon="mdi-lock-check-outline"
              variant="underlined"
              required
            ></v-text-field>

            <v-text-field
              @input="validatePassword"
              v-model="senha"
              label="Insira sua senha"
              variant="underlined"
              :hint="mensagemSenha"
              persistent-hint
              prepend-inner-icon="mdi-lock-outline"
              :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              @click:append-inner="showPassword = !showPassword"
              required
            ></v-text-field>

            <v-text-field
              @input="validatePassword"
              v-model="confirmaSenha"
              label="Confirme sua senha"
              hint="As duas senhas devem ser iguais."
              prepend-inner-icon="mdi-lock-outline"
              variant="underlined"
              :append-inner-icon="
                showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'
              "
              :type="showConfirmPassword ? 'text' : 'password'"
              @click:append-inner="showConfirmPassword = !showConfirmPassword"
              required
            ></v-text-field>

            <ul class="flex-column" style="list-style: none">
              <li>
                <div v-if="!validadores.tamanho">
                  <v-icon size="small" color="red">mdi-close-circle</v-icon>
                  <p style="color: red">Pelo menos 8 caracteres.</p>
                </div>
                <div v-else>
                  <v-icon size="small" color="green"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="color: green">Pelo menos 8 caracteres.</p>
                </div>
              </li>
              <li>
                <div v-if="!validadores.uppercase">
                  <v-icon size="small" color="red">mdi-close-circle</v-icon>
                  <p style="color: red">Pelo menos uma letra maiúscula.</p>
                </div>
                <div v-else>
                  <v-icon size="small" color="green"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="color: green">Pelo menos uma letra maiúscula.</p>
                </div>
              </li>
              <li>
                <div v-if="!validadores.numero">
                  <v-icon size="small" color="red">mdi-close-circle</v-icon>
                  <p style="color: red">Pelo menos um número.</p>
                </div>
                <div v-else>
                  <v-icon size="small" color="green"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="color: green">Pelo menos um número.</p>
                </div>
              </li>
              <li>
                <div v-if="!validadores.caractereEspecial">
                  <v-icon size="small" color="red">mdi-close-circle</v-icon>
                  <p style="color: red">
                    Pelo menos um dos caracteres: $, *, &, @, #.
                  </p>
                </div>
                <div v-else>
                  <v-icon size="small" color="green"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="color: green">
                    Pelo menos um dos caracteres: $, *, &, @, #.
                  </p>
                </div>
              </li>
              <li>
                <div v-if="!validadores.iguais">
                  <v-icon size="small" color="red">mdi-close-circle</v-icon>
                  <p style="color: red">As senhas devem coincidir.</p>
                </div>
                <div v-else>
                  <v-icon size="small" color="green"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="color: green">As senhas devem coincidir.</p>
                </div>
              </li>
            </ul>
            <br />

            <v-checkbox v-model="termoUso" density="compact" color="indigo">
              <template #label>
                <div>
                  Concordo com os
                  <a @click="this.dialog = true">
                    <strong class="text-primary">Termos de Uso </strong></a
                  >
                  .
                </div>
              </template>
            </v-checkbox>

            <v-checkbox
              v-model="termoPrivacidade"
              density="compact"
              color="indigo"
            >
              <template #label>
                <div>
                  Concordo com a
                  <a @click="this.dialogPrivacidade = true">
                    <strong class="text-primary"
                      >Política de Privacidade</strong
                    >
                  </a>
                  .
                </div>
              </template>
            </v-checkbox>

            <v-btn
              type="submit"
              block
              class="mt-2 button-config"
              rounded="pill"
            >
              Validar
            </v-btn>
          </v-form>
        </v-sheet>
      </div>
    </div>
    <div class="azul">
      <div class="div-dir">
        <img
          class="img-sispi"
          src="../assets/img/logo_dark_nobg.png"
          alt="SISGIP - Sistema de Gestão Integrada de Projetos"
        />
        <h1 class="texto-inicio">Bem-vindos ao SISGIP!</h1>
        <h1 class="texto-inicio">Sistema de Gestão Integrada de Projetos</h1>
        <br /><br />
        <h3 class="subtexto-inicio">
          Elevando a Gestão de Projetos a Novos Patamares.
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/fonts.css';
import '@/assets/css/login-validacao-cadastro.css';
import axios from 'axios';

import SnackBar from '@/components/SnackBar.vue';

const API_URL = process.env.VUE_APP_API_URL

export default {
  name: 'TelaValidacao',

  data() {
    return {
      email: '',
      nome: '',
      senha: '',
      confirmaSenha: '',
      mensagemSenha: '',
      showPassword: false,
      showConfirmPassword: false,
      token: '',
      termoUso: false,
      termoPrivacidade: false,
      dialog: false,
      dialogPrivacidade: false,
      validacao: {},
      validadores: {
        tamanho: false,
        uppercase: false,
        numero: false,
        caractereEspecial: false,
      },
    };
  },
  components: {
    SnackBar,
  },
  methods: {
    /* eslint-disable */
    /**
     * @typedef {Object} UsuarioDados
     * @property {string} email - O e-mail do usuário.
     * @property {string} token - O token do usuário.
     * @property {string} nome - O nome do usuário.
     * @property {string} senha - A senha do usuário.
     *  * @property {string} termo - Aceitou os termos de uso.
     */

    /**
     * Valida o formulário de cadastro do usuário.
     * @async
     * @function validateForm
     * @param {UsuarioDados} dados - Os dados do usuário a serem cadastrados.
     * @returns {Promise<void>} - Uma promessa vazia que é resolvida quando a validação é concluída.
     */
    async validateForm() {
      const regex = /^(?=.*[A-Z])(?=.*\d)(?=.*[$*&#@])[A-Za-z\d$*&#@]{8,}$/;

      if (regex.test(this.senha)) {
        this.mensagemSenha = 'Senha válida!';

        if (
          this.email != '' &&
          this.token != '' &&
          this.nome != '' &&
          this.senha === this.confirmaSenha &&
          this.termoUso === true &&
          this.termoPrivacidade === true
        ) {
          try {
            const response = await axios.post(`${API_URL}/usuarios`, {
              email: this.email,
              token: this.token,
              nome: this.nome,
              senha: this.senha,
            });
            this.$refs.snackbar.showSuccessSnackbar(
              'Concluído!',
              'Cadastro realizado com sucesso! Redirecionando para tela de login.'
            );
            console.log(response.data);
            this.$router.push('/login');
          } catch (error) {
            this.$refs.snackbar.showInfoSnackbar(
              'Uhm,por algum motivo não conseguimos te cadastrar!',
              'Verifique as informações e tente novamente!'
            );
            console.error(error);
          }
        } else {
          this.$refs.snackbar.showWarningSnackbar(
            'Dados Inválidos!',
            'Por favor, preencha todos os campos corretamente e tente novamente.'
          );
        }
      } else {
        this.$refs.snackbar.showWarningSnackbar(
          'Campo Senha inválido!',
          'Por favor, preencha-o corretamente e tente novamente.'
        );
        this.mensagemSenha =
          'A senha deve ter pelo menos 8 caracteres, incluindo pelo menos uma letra maiúscula, um número e um dos seguintes caracteres: $, *, &, @, #.';
      }
    },

    validatePassword() {
      const password = this.senha;
      const confirmaPassword = this.confirmaSenha;
      this.validadores = {
        tamanho: password.length >= 8,
        uppercase: /[A-Z]/.test(password),
        numero: /[0-9]/.test(password),
        caractereEspecial: /[$*&@#]/.test(password),
        iguais: confirmaPassword === this.senha,
      };

      // Caso queira deixar o botão disable, o validacao serve para verificar todos os validadores
      this.validacao = Object.values(this.validadores).every(
        (validadores) => validadores
      );
    },
  },
  /* eslint-enable */
};
</script>

<style scoped>
.custom-row {
  margin-bottom: 8px; /* Ajuste o valor conforme necessário */
}
.azul {
  height: 130vh;
}
.flex-column {
  display: flex;
  flex-direction: column;
}
li div {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  float: left;
}
</style>
